import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { images } from '../../constants'
import { AppWrap } from '../../wrapper';
import { client } from '../../client';

import './Header.scss'

const scaleVariants = {
  whileInView: {
    scale: [0,1],
    opacity:[0,1],
    transition: {
      duration:1,
      ease:'easeInOut'
    }
  }
}

const Header = () => {
  const [resumeData, setResumeData] = useState(null);

  useEffect(() => {
    const query = '*[_type == "resume" && isActive == true][0]';
    client.fetch(query).then(data => {
      setResumeData(data);
    }).catch(err => console.error('Error fetching resume:', err));
  }, []);

  return (
    <div className='app__header app__flex'>
        <motion.div
          whileInView={{x:[-10,0],opacity:[0,1]}}
          transition={{ duration:2}}
          className='app__header-info'
        >
            <div className='app__header-badge'>
                <div className='badge-cmp app__flex'>
                    <span>👋</span>
                    <div style={{marginLeft:20}}>
                        <p className='p-text'>Hello, I am</p>
                        <h1 className='head-text'>Natanim</h1>
                        <p className='p-text'>Full-stack Developer</p>
                        <p className='p-text'>Freelancer</p>
                    </div>
                </div>
                
                {resumeData && (
                  <motion.a 
                    href={resumeData.resumeLink} 
                    target='_blank' 
                    rel='noreferrer'
                    className='app__resume-btn'
                    whileInView={{opacity:1}}
                    whileHover={{scale:1.1}}
                    transition={{duration:0.5,type:'tween'}}
                    title={resumeData.downloadText}
                  >
                    <h4 className='head-text'>{resumeData.title}</h4>
                  </motion.a>
                )}
            </div>

        </motion.div>
        <motion.div
          whileInView={{opacity:[0,1]}}
          transition={{ duration:2,delayChildren:0.5}}
          className='app__header-img'
        >
          <img className='app__header-profile' src={images.profile} alt="profile"/>
          <motion.img
            whileInView={{scale:[0,1]}}
            transition={{ duration:1, ease:'easeInOut'}}
            src={images.circle}
            alt="profile_circle"
            className='overlay_circle'
          />
        </motion.div>

        <motion.div
          variants={scaleVariants}
          whileInView= {scaleVariants.whileInView}
          className='app__header-circles'
        >
          {[images.spring,images.angular,images.rails,images.next,images.graphql].map((circle,index) => (
            <div className='circle-cmp app__flex' key={`circle-${index}`}>
                <img src={circle} alt="circle"/>
            </div>
          ))}

        </motion.div>
    </div>
  )
}

export default AppWrap(Header, 'home')
